import styles from './Indicator.module.css';

const Indicator = ({ status, outerStyle, innerStyle }) => {
  let outer = 'outer';
  let dot = 'dot';

  switch (status) {
    case 'Operativna':
      outer = 'outer';
      dot = 'dot';
      break;
    case 'Van upotrebe':
    case 'Out of Use':
      outer = 'notActiveOuter';
      dot = 'notActiveDot';
      break;
    case 'U servisu':
      outer = 'servisOuter';
      dot = 'servisDot';
      break;
    case 'In Service':
      outer = 'servisOuter';
      dot = 'servisDot';
      break;
    case 'Delimično operativna':
      outer = 'servisOuter';
      dot = 'servisDot';
      break;

    case 'Partially Operational':
      outer = 'servisOuter';
      dot = 'servisDot';
      break;

    default:
      outer = 'outer';
      dot = 'dot';
      break;
  }

  return (
    <div
      style={
        status === 'Van upotrebe' || status === 'Out of Use' ? outerStyle : null
      }
      className={styles[outer]}
    >
      <div style={innerStyle} className={styles[dot]} />
    </div>
  );
};

export default Indicator;
